var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_1842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58301 14.1667V15.8333C3.58301 16.2754 3.7586 16.6993 4.07116 17.0119C4.38372 17.3244 4.80765 17.5 5.24967 17.5H15.2497C15.6917 17.5 16.1156 17.3244 16.4282 17.0119C16.7407 16.6993 16.9163 16.2754 16.9163 15.8333V14.1667M6.08301 9.16668L10.2497 13.3333M10.2497 13.3333L14.4163 9.16668M10.2497 13.3333V3.33334",
    stroke: "#347D73",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_1842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.8846e6efc64733d339e1fbb9dc78de22.svg";
export { ForwardRef as ReactComponent };